export enum KycQuestionIdentifiersConstant {
  MPP_PERSONAL_INFORMATION_NAME = 'mpp-personal-information-name',
  MPP_PERSONAL_INFORMATION_BIRTH = 'mpp-personal-information-birth',
  MPP_FAMILY_SITUATION = 'mpp-family-situation',
  MPP_PROFESSIONAL_INFORMATION_STATUS = 'mpp-professional-information-status',
  MPP_PERSONAL_INFORMATION_PHONE = 'mpp-personal-information-phone',
  MPP_PERSONAL_INFORMATION_ADDRESS = 'mpp-personal-information-address'
}

